// In App.js
import { Navigate } from "react-router-dom";
import { useState,useEffect } from "react";
import usefbStore from "../store/firebasestore";

import { auth } from "../firebase/firebase";
// Create a ProtectedAdminRoute component
const ProtectedAdminRoute = ({ children }) => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const authStatus = usefbStore((s) => s.authStatus);

  useEffect(() => {
    const checkAdmin = async () => {
      if (authStatus !== "authenticated") {
        setIsLoading(false);
        return;
      }
      
      const user = auth.currentUser;
      if (user) {
        const token = await user.getIdTokenResult();
        setIsAdmin(token.claims.admin === true);
      }
      setIsLoading(false);
    };
    
    checkAdmin();
  }, [authStatus]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return isAdmin ? children : <Navigate to="/" />;
};

export default ProtectedAdminRoute